import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      variant: 'flex.row.start.center',
      flexWrap: 'wrap',
      gap: [6, 11],
      mt: [2, 2, 4],
      mb: [5, 5, 11],
    };

    this.iconsRow = {
      variant: 'flex.row.start.start',
    };

    this.icon = {
      width: '20px',
      mr: 3,
    };

    this.label = {
      variant: 'text.label.2',
      maxWidth: '175px',
      mt: '1px',
    };
  })()
);
